module.exports = __webpack_public_path__ + "static/media/Vendas8.af15e074.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas8.png
// module id = 1779
// module chunks = 0